import React from 'react';

import Images from '../Images';
import { logo } from '../../images';
import dayjs from "dayjs";

const Footer = ({ page }) => {
	return (
		<div className='Page__footer'>
			<div className={'ohs-footer'}>
				<div className={'ohs-footer__line'} />
				<div className={'ohs-footer__content'}>
					<div className={'ohs-footer__logo'}>
						<img src={Images.report.fullMarkColorLogo} alt='tablegroup-logo' />
					</div>
					<div className={'ohs-footer__text'}>
						<span className={'ohs-footer__link'}>Tablegroup.com</span>
						<span> | &copy; Copyright {dayjs().format("YYYY")} The Table Group, Inc.</span>
					</div>
					<div className={'ohs-footer__page'}>
						<span>{page}</span>
						<img className={'ohs-footer__page-logo'} src={logo} alt='logo' />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
